const ContainerHeaderMappings = {
  Name: 'name',
  'Ref Id': 'reference_id',
  capacity: 'capacity',
  'Tare Weight': 'tare_weight',
  'Max Gross Weight': 'max_gross_weight',
  'Max Payload': 'max_payload',
  'Exterior Length': 'container_dimension_exterior_length',
  'Exterior Height': 'container_dimension_exterior_height',
  'Exterior Width': 'container_dimension_exterior_width',
  'Interior Length': 'container_dimension_interior_length',
  'Interior Height': 'container_dimension_interior_height',
  'Interior Width': 'container_dimension_interior_width',
  'Door Opening Width': 'container_dimension_door_opening_width',
  'Door Opening Height': 'container_dimension_door_opening_height',
  'Preferred Truck Type': 'preferred_truck_type',
};

const validContainerHeaders = [
  'Name',
  'Ref Id',
  'capacity',
  'Tare Weight',
  'Max Gross Weight',
  'Max Payload',
  'Exterior Length',
  'Exterior Height',
  'Exterior Width',
  'Interior Length',
  'Interior Height',
  'Interior Width',
  'Door Opening Width',
  'Door Opening Height',
];

module.exports = {
  validContainerHeaders,
  ContainerHeaderMappings,
};
